import {atom} from "recoil";

const initLang = localStorage.getItem('lang');

const langAtom = atom({
    key: 'lang',
    default: initLang && typeof initLang !== 'undefined' ? initLang : 'en'
});

export default langAtom;